/**
 * Constantes globales de la aplicación
 * @module constants
 */

// ============================================================================
// COLORES DE NODOS
// ============================================================================

export const NODE_COLORS = {
  OLT: '#22c55e',
  POP: '#ec4899',
  NAP: '#3b82f6',
  CIERRE: '#f59e0b',
  CLIENTE: '#a855f7',
  POSTE: '#94a3b8',
} as const

// ============================================================================
// ICONOS DE NODOS (Emojis)
// ============================================================================

export const NODE_ICONS = {
  OLT: '📡',
  POP: '🏢',
  NAP: '🟦',
  CIERRE: '🟥',
  CLIENTE: '👤',
  POSTE: '📍',
} as const

// ============================================================================
// CONFIGURACIÓN DEL MAPA
// ============================================================================

export const MAP_CONFIG = {
  DEFAULT_CENTER: {
    lat: 21.1619,
    lng: -86.8515,
  },
  DEFAULT_ZOOM: 14,
  MIN_ZOOM: 3,
  MAX_ZOOM: 19,
  TILE_LAYER: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  ATTRIBUTION: '© OpenStreetMap contributors',
  /** Esri World Imagery — revisar términos de uso en producción comercial */
  SATELLITE_TILE_LAYER:
    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  SATELLITE_ATTRIBUTION:
    'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
  /** CartoDB Voyager (estilo calle alternativo) */
  TERRAIN_TILE_LAYER: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
  TERRAIN_ATTRIBUTION: '© OpenStreetMap contributors © CARTO',
} as const

// ============================================================================
// TAMAÑOS Y ESTILOS
// ============================================================================

export const UI_CONFIG = {
  SIDEBAR_WIDTH: 280,
  PANEL_WIDTH: 350,
  NODE_MARKER_SIZE: 20,
  NODE_MARKER_SELECTED_SIZE: 28,
  CABLE_LINE_WIDTH: 3,
  CABLE_LINE_OPACITY: 0.7,
} as const

// ============================================================================
// VALIDACIONES
// ============================================================================

export const VALIDATION = {
  MAX_FOLDER_DEPTH: 5,
  MAX_FIBER_ATTENUATION: 28, // dB
  WARNING_FIBER_ATTENUATION: 25, // dB
  MIN_FIBER_POWER: -28, // dBm
  MAX_CABLE_LENGTH: 100000, // metros
} as const

// ============================================================================
// PREFIJOS DE ID POR TIPO
// ============================================================================

export const ID_PREFIXES = {
  OLT: 'OLT',
  POP: 'POP',
  NAP: 'NAP',
  CIERRE: 'CIE',
  CLIENTE: 'CLI',
  POSTE: 'POS',
  CABLE: 'CAB',
  FOLDER: 'FOLDER',
  PROJECT: 'PROJ',
} as const

// ============================================================================
// RATIOS DE SPLITTER DISPONIBLES
// ============================================================================

export const SPLITTER_RATIOS = [
  '1:2',
  '1:4',
  '1:8',
  '1:16',
  '1:32',
  '1:64',
] as const

// ============================================================================
// ATENUACIÓN TÍPICA POR TIPO
// ============================================================================

export const TYPICAL_ATTENUATION = {
  FIBER_PER_KM: 0.3, // dB/km
  SPLICE_FUSION: 0.05, // dB
  SPLICE_MECHANICAL: 0.1, // dB
  CONNECTOR: 0.25, // dB
  SPLITTER_1_2: 3.5, // dB
  SPLITTER_1_4: 7, // dB
  SPLITTER_1_8: 10.5, // dB
  SPLITTER_1_16: 14, // dB
  SPLITTER_1_32: 17.5, // dB
  SPLITTER_1_64: 21, // dB
} as const

// ============================================================================
// TIPOS DE CAJA NAP DISPONIBLES
// ============================================================================

export const NAP_BOX_TYPES = [
  'NAP aérea',
  'NAP pedestal',
  'NAP mural',
  'NAP subterránea',
] as const

// ============================================================================
// TIPOS DE CIERRE DISPONIBLES
// ============================================================================

export const CLOSURE_TYPES = [
  'Domo',
  'Tipo bote',
  'Horizontal',
  'Vertical',
  'Inline',
] as const

// ============================================================================
// ALMACENAMIENTO LOCAL
// ============================================================================

export const STORAGE_KEYS = {
  NODES: 'neteasyftx_nodes',
  CABLES: 'neteasyftx_cables',
  FOLDERS: 'neteasyftx_folders',
  PROJECTS: 'neteasyftx_projects',
  FIBER_CONNECTIONS: 'neteasyftx_fiber_connections',
  UI_CONFIG: 'neteasyftx_ui_config',
  USER_PREFERENCES: 'neteasyftx_user_prefs',
} as const

// ============================================================================
// VERSIÓN DE LA APLICACIÓN
// ============================================================================

export const APP_VERSION = '0.1.0'
export const APP_NAME = 'NetEasyFTTX'
